import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from 'react-helmet-async';

// Contexts
import { SiteSettingsProvider } from "./contexts/SiteSettingsContext";

// Components
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ChatWidget } from "./components/ChatWidget";
import { DemoModal } from "./components/DemoModal";

// Pages
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Technology } from "./pages/Technology";
import { CaseStudies } from "./pages/CaseStudies";
import { Careers } from "./pages/Careers";
import { Contact } from "./pages/Contact";
import { Staffing } from "./pages/Staffing";

function App() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const openDemoModal = () => setIsDemoModalOpen(true);
  const closeDemoModal = () => setIsDemoModalOpen(false);

  return (
    <HelmetProvider>
      <SiteSettingsProvider>
        <div className="App min-h-screen bg-[#090B17]">
          <BrowserRouter>
            <Navbar onDemoClick={openDemoModal} />
            
            <main>
              <Routes>
                <Route path="/" element={<Home onDemoClick={openDemoModal} />} />
                <Route path="/about" element={<About onDemoClick={openDemoModal} />} />
                <Route path="/services" element={<Services onDemoClick={openDemoModal} />} />
                <Route path="/technology" element={<Technology onDemoClick={openDemoModal} />} />
                <Route path="/case-studies" element={<CaseStudies onDemoClick={openDemoModal} />} />
                <Route path="/careers" element={<Careers onDemoClick={openDemoModal} />} />
                <Route path="/contact" element={<Contact onDemoClick={openDemoModal} />} />
                <Route path="/staffing" element={<Staffing onDemoClick={openDemoModal} />} />
              </Routes>
            </main>

            <Footer />
            {/* <ChatWidget /> */}
            <DemoModal isOpen={isDemoModalOpen} onClose={closeDemoModal} />
            
            <Toaster 
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#151E32',
                  color: '#E2E8F0',
                  border: '1px solid #334155'
                }
              }}
            />
          </BrowserRouter>
        </div>
      </SiteSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
